export const LOAD_PROVINCE = "LOAD_PROVINCE";
export const ADD_PROVINCE = "ADD_PROVINCE";
export const UPDATE_PROVINCE = "UPDATE_PROVINCE";
export const DELETE_PROVINCE = "DELETE_PROVINCE";
